export default function SeatmapAvailabilityService(
    userService,
    supplierService,
    flightRecommendationService
) {
    'ngInject';

    Object.assign(this, {
        isSeatmapAvailableForFlightRecommendation,
        isSeatmapAvailableForFlightGroup,
        isSeatmapAvailableForFlight,
    });

    function isSeatmapAvailableForFlightRecommendation(flightRecommendation) {
        const flightSupplierId = flightRecommendationService.getFlightSupplierId(flightRecommendation);

        return userService.isSeatMapServiceAvailable()
            && supplierService.isAmadeusFlightId(flightSupplierId)
            && !flightRecommendationService.isTrain(flightRecommendation)
            && flightRecommendationService.getFlights(flightRecommendation).some(areFreeOrPaidSeatsAllowedForFlight);
    }

    function areFreeOrPaidSeatsAllowedForFlight(flight) {
        return flight.AreFreeSeatsAllowed
            || flight.ArePaidSeatsAllowed;
    }

    function isSeatmapAvailableForFlightGroup(flightGroup) {
        if (!(flightGroup && flightGroup.Flights && flightGroup.Flights.length)) {
            return false;
        }

        return userService.isSeatMapServiceAvailable()
            && flightGroup.Flights.some((flight) =>
                supplierService.isAmadeusFlightId(flight.SupplierId)
                    && !flightRecommendationService.isTrain(flight)
                    && areFreeOrPaidSeatsAllowedForFlight(flight));
    }

    function isSeatmapAvailableForFlight(flight) {
        return userService.isSeatMapServiceAvailable()
            && supplierService.isAmadeusFlightId(flight.SupplierId)
            && !flightRecommendationService.isTrain(flight)
            && (flight.AreFreeSeatsAllowed || flight.ArePaidSeatsAllowed);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-seatmap/seatmap-availability-service.js